import { useId } from 'react'

import { cn } from '../../../../lib/utils.ts'

import { useRegisterItemMetadata } from './item-metadata-context.ts'

export function ItemDetails(props: ItemDetails.Props) {
  const { className, id, ...rest } = props
  const generatedId = useId()
  const resolvedId = id ?? generatedId
  useRegisterItemMetadata('details', resolvedId)
  return <span id={resolvedId} data-slot="item-details" className={cn(className)} {...rest} />
}

export namespace ItemDetails {
  export type Props = React.ComponentProps<'span'>
}
